export default {
  user: state => state.user.user,
  allSchoolList: state => state.school.allSchoolList, // 全部培训机构
}


// WEBPACK FOOTER //
// ./src/store/getters.js